<template>
  <div class="container mx-auto px-4">
    <SwishData />
  </div>
</template>
